import {
  Button,
  Disclosure,
  DisclosurePanel,
  Heading,
} from 'react-aria-components';
import Plus from '@/assets/icons/Plus.svg';
import * as Styled from './Disclosures.styled';

interface Group {
  content: string;
  key: string;
  triggerText: string;
}

interface AccordionProps {
  expandedKeys?: string[];
  groups: Group[];
}

export const Disclosures = ({ expandedKeys, groups }: AccordionProps) => (
  <Styled.Disclosures allowsMultipleExpanded defaultExpandedKeys={expandedKeys}>
    {groups.map(({ content, key, triggerText }) => (
      <Disclosure id={key} key={key}>
        <Heading level={2}>
          <Button slot="trigger">
            {triggerText} <Plus />
          </Button>
        </Heading>
        <DisclosurePanel>
          {/* biome-ignore lint/security/noDangerouslySetInnerHtml: we trust the source of the HTML */}
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </DisclosurePanel>
      </Disclosure>
    ))}
  </Styled.Disclosures>
);
